import React from 'react'

const Baner = (props) => {
  return (
    <section className="bg-gray-800 text-bezowyPW" id="baner">

      <div
        className="container mx-auto flex flex-col items-center px-4 py-16 text-center md:py-32 ">
        <img src={props.data} alt="" className="object-contain sm:h-90 lg:h-106 xl:h-122 2xl:h-138"/>
        <div
          className="container mx-auto flex flex-col items-center px-30 py-16 text-center md:py-15 md:px-30 lg:px-30 xl:max-w-5xl">
          <h1 className="text-4xl font-bold leading-none sm:text-5xl">Gala Młodych Naukowców</h1>
          <p className="mt-6 mb-8 text-lg sm:mb-12 text-bezowyPW"> 1. edycja Gali organizowana z inicjatywy Rady
            Doktorantów Politechniki Warszawskiej
            to wydarzenie składające się z trzech związanych
            ze sobą inicjatyw – Kongresu, Wystawy Posterów oraz Balu Młodych Naukowców PW.
          </p>

          <div
            className="flex flex-col space-y-4 sm:items-center sm:justify-center sm:flex-row sm:space-y-0 sm:space-x-4 lg:justify-start">
            <a rel="noopener noreferrer" href="#pricing"
               className="px-8 py-3 text-lg font-semibold rounded bg-orangePW text-gray-100 hover:text-greenPW">Kup
              Bilet</a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Baner
